import { segment } from '@actions/analytics';

export const UPSC_ANALYSIS_CTA_CLICKED =
  'UPSC Current Affairs - Analysis CTA Clicked';
export const UPSC_QUIZ_CTA_CLICKED = 'UPSC Current Affairs - Quiz CTA Clicked';
export const UPSC_QUIZ_STARTED = 'UPSC Current Affairs - Quiz Started';
export const UPSC_CALENDAR_CTA_CLICKED =
  'UPSC Current Affairs - Calendar CTA Clicked';
export const UPSC_DAILY_PDF_CTA_CLICKED =
  'UPSC Current Affairs - Daily PDF CTA Clicked';
export const UPSC_MONTHLY_PDF_CTA_CLICKED =
  'UPSC Current Affairs - Monthly PDF CTA Clicked';
export const UPSC_PDF_DOWNLOAD_CLICKED =
  'UPSC Current Affairs - PDF Download Clicked';
export const UPSC_MONTHLY_CLASSES_CTA_CLICKED =
  'UPSC Current Affairs - Monthly Classes CTA Clicked';
export const UPSC_SUBJECT_WISE_CTA_CLICKED =
  'UPSC Current Affairs - Subject Wise CTA Clicked';
export const UPSC_TOPIC_DETAILS = 'UPSC Current Affairs - Topic Details';
export const UPSC_TOPIC_SHARED = 'UPSC Current Affairs - Topic Shared';

type TopicEventInput = {
  topicId?: string | number | null;
  topicTitle?: string | null;
  topicDate?: string | null;
  subjectName?: string | null;
};

type MonthlyPdfCtaInput = {
  ctaText: string;
  pdfMonth?: string | null;
  pdfYear?: string | null;
};

const toAnalyticsValue = (value?: string | number | null) => {
  if (value === undefined || value === null) {
    return 'NA';
  }

  const text = String(value).trim();
  return text || 'NA';
};

export const trackUpscAnalysisCtaClicked = (ctaText: string) => {
  segment.track(UPSC_ANALYSIS_CTA_CLICKED, {
    cta_text: ctaText
  });
};

export const trackUpscQuizCtaClicked = (ctaText: string) => {
  segment.track(UPSC_QUIZ_CTA_CLICKED, {
    cta_text: ctaText
  });
};

export const trackUpscCalendarCtaClicked = (ctaText: string) => {
  segment.track(UPSC_CALENDAR_CTA_CLICKED, {
    cta_text: ctaText
  });
};

export const trackUpscDailyPdfCtaClicked = (ctaText: string) => {
  segment.track(UPSC_DAILY_PDF_CTA_CLICKED, {
    cta_text: ctaText
  });
};

export const trackUpscMonthlyPdfCtaClicked = ({
  ctaText,
  pdfMonth,
  pdfYear
}: MonthlyPdfCtaInput) => {
  segment.track(UPSC_MONTHLY_PDF_CTA_CLICKED, {
    cta_text: ctaText,
    pdf_month: toAnalyticsValue(pdfMonth),
    pdf_year: toAnalyticsValue(pdfYear)
  });
};

export const trackUpscMonthlyClassesCtaClicked = (ctaText: string) => {
  segment.track(UPSC_MONTHLY_CLASSES_CTA_CLICKED, {
    cta_text: ctaText
  });
};

export const trackUpscPdfDownloadClicked = ({
  pdfType,
  pdfName,
  pdfDate,
  language
}: {
  pdfType: string;
  pdfName: string;
  pdfDate: string;
  language: string;
}) => {
  segment.track(UPSC_PDF_DOWNLOAD_CLICKED, {
    pdf_type: pdfType,
    pdf_name: pdfName,
    pdf_date: pdfDate,
    language
  });
};

const getTopicEventProperties = ({
  topicId,
  topicTitle,
  topicDate,
  subjectName
}: TopicEventInput) => ({
  topic_id: toAnalyticsValue(topicId),
  topic_title: toAnalyticsValue(topicTitle),
  topic_date: toAnalyticsValue(topicDate),
  subject_name: toAnalyticsValue(subjectName)
});

export const trackUpscTopicDetails = (topic: TopicEventInput) => {
  segment.track(UPSC_TOPIC_DETAILS, getTopicEventProperties(topic));
};

export const trackUpscTopicShared = (topic: TopicEventInput) => {
  segment.track(UPSC_TOPIC_SHARED, getTopicEventProperties(topic));
};

export const trackUpscSubjectWiseCtaClicked = ({
  ctaText,
  subjectName = 'NA'
}: {
  ctaText: string;
  subjectName?: string;
}) => {
  segment.track(UPSC_SUBJECT_WISE_CTA_CLICKED, {
    cta_text: ctaText,
    subject_name: subjectName
  });
};

export const trackUpscQuizStarted = ({
  quizType,
  redirectUrl
}: {
  quizType: 'Daily' | 'Weekly';
  redirectUrl: string;
}) => {
  segment.track(UPSC_QUIZ_STARTED, {
    quiz_type: quizType,
    redirect_url: redirectUrl
  });
};
